import axios from "api/axios"
import {
  APIResponse,
  Config,
  ConfigWithURLParams,
  NoContentType,
} from "api/types"
import { formatErrorResponse, formatSuccessResponse } from "api/utils"

import {
  AcceptEnrollmentAgreementsPayload,
  EnrollmentAgreementSlugs,
} from "./types"
import { urls } from "./urls"

export default {
  listSlugs: async ({
    urlParams,
  }: ConfigWithURLParams<"productSlug">): Promise<
    APIResponse<EnrollmentAgreementSlugs>
  > => {
    try {
      const res = await axios.get(urls.slugs(urlParams.productSlug))
      return formatSuccessResponse(res)
    } catch (e) {
      const error = formatErrorResponse(e)
      throw error
    }
  },

  accept: async ({
    data,
  }: Omit<Config, "data"> & {
    data: AcceptEnrollmentAgreementsPayload
  }): Promise<APIResponse<NoContentType>> => {
    try {
      const res = await axios.post(urls.accept(), data)
      return formatSuccessResponse(res)
    } catch (e) {
      const error = formatErrorResponse(e)
      throw error
    }
  },
}
